// Reconstruit l'historique du capital total du portefeuille à partir des transactions
// clôturées, pour le graphique "Capital total" (accueil + sa version plein écran).

export const CAPITAL_PERIODS = ['1A', '2A', '5A', '10A', 'MAX'];

// Temps fictif (comme le graphique d'un actif) : 1 année fictive = 1440 minutes réelles,
// mêmes paliers que `getDatabayPeriodvertuelbougiev2` côté backend.
const LOOKBACK_MINUTES = { '1A': 1440, '2A': 2880, '5A': 7200, '10A': 14400, 'MAX': null };

export const getPeriodStart = (label) => {
    const minutes = LOOKBACK_MINUTES[label];
    if (minutes == null) return null;
    return new Date(Date.now() - minutes * 60000);
};

export function buildCapitalHistory(portefeuilledata, allTxs, period) {
    const current = parseFloat(portefeuilledata?.montant_actuel) || 0;
    const initial = parseFloat(portefeuilledata?.montant_initial) || 0;
    if (!current || !initial) return { periodHistory: [], periodPct: 0, periodChange: 0 };

    const periodStart = getPeriodStart(period);

    // On ne garde que les transactions réellement clôturées (gain_loss réalisé)
    const closedTxs = [...(allTxs || [])]
        .filter(t => t.status === 'closed' && parseFloat(t.gain_loss) !== 0)
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

    // Capital au début de la période = capital initial + tous les gains clôturés AVANT la période
    const txsBeforePeriod = periodStart
        ? closedTxs.filter(t => new Date(t.created_at) < periodStart)
        : [];
    const txsInPeriod = periodStart
        ? closedTxs.filter(t => new Date(t.created_at) >= periodStart)
        : closedTxs;

    const startCapital = initial + txsBeforePeriod.reduce((s, t) => s + (parseFloat(t.gain_loss) || 0), 0);

    // Historique : part du capital de début de période, ajoute chaque trade clôturé dans la période,
    // termine sur montant_actuel (ancre la courbe sur la réalité, unrealized inclus)
    let running = startCapital;
    const history = [startCapital];
    for (const tx of txsInPeriod) {
        running += parseFloat(tx.gain_loss) || 0;
        history.push(running);
    }
    history.push(current);

    const pct = startCapital > 0 ? ((current - startCapital) / startCapital) * 100 : 0;
    const change = current - startCapital;
    return { periodHistory: history, periodPct: pct, periodChange: change };
}
